<script setup lang="ts">
export interface GrammarDividerProps {
  type?: 'default' | 'button';
  orientation?: 'horizontal' | 'vertical';
  emphasis?:
    | 'x-high-emphasis'
    | 'high-emphasis'
    | 'default-emphasis'
    | 'low-emphasis'
    | 'x-low-emphasis';
}

const props = withDefaults(defineProps<GrammarDividerProps>(), {
  type: 'default',
  orientation: 'horizontal',
  emphasis: 'default-emphasis',
});
</script>

<template>
  <tpg-divider v-bind="props" />
</template>
